import { Injectable, inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

import { EnvironmentService } from '@core/services/environment.service';

@Injectable({ providedIn: 'root' })
export class AuthSessionCheckService {
	private readonly oauthService = inject(OAuthService);
	private readonly environmentService = inject(EnvironmentService);

	async isStillAuthenticated(): Promise<boolean> {
		const token = this.oauthService.getAccessToken();

		if (!token) {
			return false;
		}

		try {
			const loginPingUrl = this.environmentService.loginPingUrl || 'https://login-dev.witglobal.net';
			const userInfoEndpoint = `${loginPingUrl}/idp/userinfo.openid`;

			const response = await fetch(userInfoEndpoint, {
				method: 'GET',
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});

			if (!response.ok) {
				return false;
			}

			const data = await response.json();
			return !!data?.sub;
		} catch (_error) {
			return false;
		}
	}
}
